import { loadIndexes } from '@data/indexes';
import type { Peuple } from '@data/schemas';
import { formatModCaracEntry } from '@domain/peuple';
import { normalize } from '@features/search';
import { html } from 'lit';
import { buildHref } from '../router';

export async function renderPeuplesPage(): Promise<unknown> {
  const idx = await loadIndexes();
  const peuples = idx.bdd.peuples.peuples;

  const fmtMod = (p: Peuple): string =>
    [...(p.modificateurs_carac.bonus ?? []), ...(p.modificateurs_carac.malus ?? [])]
      .map(formatModCaracEntry)
      .join(' · ');

  const matches = (p: Peuple, q: string): boolean => normalize(`${p.nom} ${fmtMod(p)}`).includes(q);

  const render = (p: Peuple) => html`
    <a href=${buildHref('peuple', { id: p.id })} class="list-card" data-tilt>
      <span class="list-card-title">${p.nom}</span>
      <span class="list-card-sub">
        ${(p.modificateurs_carac.bonus ?? []).map((b) => html`<span class="peuple-mod peuple-mod-bonus">${formatModCaracEntry(b)}</span> `)}
        ${(p.modificateurs_carac.malus ?? []).map((m) => html`<span class="peuple-mod peuple-mod-malus">${formatModCaracEntry(m)}</span> `)}
      </span>
    </a>
  `;

  return html`
    <div class="list-page">
      <header class="list-page-header">
        <h1 class="list-page-title" data-morph data-morph-duration="1500">Peuples</h1>
        <p class="list-page-subtitle">${peuples.length} peuples jouables dans les Terres d'Osgild.</p>
      </header>
      <cof2-search-grid
        .items=${peuples}
        .predicate=${matches}
        .renderItem=${render}
        placeholder="Rechercher un peuple..."
      ></cof2-search-grid>
    </div>
  `;
}
